"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const BarChartIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0,0,34,34" }),
    react_1.default.createElement("path", { d: "M4.02081,5.02084c-0.55231,0-1,0.44769-1,1v22c0,0.55231,0.44769,1,1,1h6c0.55231,0,1-0.44769,1-1v-22   c0-0.55231-0.44769-1-1-1H4.02081z" }),
    react_1.default.createElement("path", { d: "M14.03125,1.05209c-0.55231,0-1,0.44769-1,1v26c0,0.55231,0.44769,1,1,1h6c0.55225,0,1-0.44769,1-1v-26   c0-0.55231-0.44775-1-1-1H14.03125z" }),
    react_1.default.createElement("path", { d: "M23.98956,11.02084c-0.55231,0-1,0.44769-1,1v16c0,0.55231,0.44769,1,1,1h6c0.55231,0,1-0.44769,1-1v-16   c0-0.55231-0.44769-1-1-1H23.98956z" }),
    react_1.default.createElement("path", { d: "M32,30.94791H2c-0.55231,0-1,0.44775-1,1c0,0.55231,0.44769,1,1,1h30c0.55225,0,1-0.44769,1-1   C33,31.39566,32.55225,30.94791,32,30.94791z" })));
exports.BarChartIcon = BarChartIcon;
exports.default = exports.BarChartIcon;
